import React, { useState } from 'react'

import { AuthShieldContext } from './AuthShieldContext'
import { changeIsAuthed, getIsAuthed } from './AuthShieldLocalStorage'
import { IAuthShieldContextValue } from './types'

interface IAuthShieldContextProviderProps {
  children: React.ReactNode
}

const AuthShieldContextProvider = ({ children }: IAuthShieldContextProviderProps) => {
  const [isAuthedState, setIsAuthedState] = useState(getIsAuthed())
  const [isLoggingOut, setIsLoggingOut] = useState(false)
  return (
    <AuthShieldContext.Provider
      value={
        {
          isAuthed: isAuthedState,
          setIsAuthed: (bool: boolean) => {
            changeIsAuthed(bool)
            setIsAuthedState(bool)
          },
          isLoggingOut,
          setIsLoggingOut,
        } as IAuthShieldContextValue
      }
    >
      {children}
    </AuthShieldContext.Provider>
  )
}

export default AuthShieldContextProvider
